import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try {
            const raw = localStorage.getItem("uncloned_user");
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("uncloned_token");
        if (!token) {
            setLoading(false);
            return;
        }
        api.get("/auth/me")
            .then((r) => {
                setUser(r.data);
                localStorage.setItem("uncloned_user", JSON.stringify(r.data));
            })
            .catch(() => {
                localStorage.removeItem("uncloned_token");
                localStorage.removeItem("uncloned_user");
                setUser(null);
            })
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("uncloned_token", data.token);
        localStorage.setItem("uncloned_user", JSON.stringify(data.user));
        setUser(data.user);
        return data.user;
    };

    const signup = async (payload) => {
        const { data } = await api.post("/auth/signup", payload);
        localStorage.setItem("uncloned_token", data.token);
        localStorage.setItem("uncloned_user", JSON.stringify(data.user));
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        localStorage.removeItem("uncloned_token");
        localStorage.removeItem("uncloned_user");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, signup, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
